import { render, staticRenderFns } from "./commom-problem.vue?vue&type=template&id=40c4fbf6&scoped=true&"
import script from "./commom-problem.vue?vue&type=script&lang=js&"
export * from "./commom-problem.vue?vue&type=script&lang=js&"
import style0 from "./commom-problem.vue?vue&type=style&index=0&id=40c4fbf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c4fbf6",
  null
  
)

export default component.exports